var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-popover",
        {
          attrs: {
            placement: "right",
            trigger: "hover",
            delay: { show: 100, hide: 500 },
          },
        },
        [
          _c("i", { staticClass: "pointer icon-fa icon-fa-bell" }),
          _vm._v(" "),
          _c("template", { slot: "popover" }, [
            _c(
              "div",
              _vm._l(_vm.records, function (r) {
                return _c("div", { staticClass: "card" }, [
                  _c("div", { staticClass: "card-header p-2" }, [
                    _c("strong", [
                      _vm._v(_vm._s(r.type_id === 28 ? "UTEKA" : "003")),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "card-body p-1" },
                    _vm._l(r.task_data.conditions, function (c, i) {
                      return c.value
                        ? _c("p", [
                            _c("span", {
                              domProps: { innerHTML: _vm._s(c.title) },
                            }),
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  !c.condition
                                    ? "="
                                    : c.condition === "more"
                                    ? ">"
                                    : "<"
                                ) +
                                " " +
                                _vm._s(c.value)
                            ),
                          ])
                        : _vm._e()
                    }),
                    0
                  ),
                ])
              }),
              0
            ),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }